import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";

export function isVoltronEnabled(mailboxInfo: MailboxInfo): boolean {
    return isAccountFeatureEnabled("mon-copilot-voltron", mailboxInfo);
}
